import { ReactElement, useState } from 'react';
import { Component as ChevronDownIcon } from 'icons/icon-ui--chevron-down.svg';
import { Component as ChevronUpIcon } from 'icons/icon-ui--chevron-up.svg';
import { parseZone } from 'moment/moment';
import { Route } from '../../utils/config';
import { MenuSelector } from './MenuSelector';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import styles from './MenuSelector.module.scss';

function MenuSelectorContainer(): ReactElement {
  const [isOpen, setIsOpen] = useState(false);
  const {
    upcomingMenus,
    menu,
    onSelectMenu,
  } = useMenuWithCart();
  const menuWeeks = upcomingMenus?.menus.map((upcomingMenu) => ({
    deliveryDate: upcomingMenu.deliveryOn,
    isSelectedMenu: menu?.id === upcomingMenu?.id,
    menuId: upcomingMenu.id,
    cartId: upcomingMenu.cartId,
    isSkipped: upcomingMenu.isSkipped,
  })) ?? [];

  const menuSelectorDate = menu?.deliveryOn ? parseZone(menu?.deliveryOn)
    .format('ddd, MMM D') : '';

  const isHubActive = window.location.pathname === Route.HUB;

  const handleClickOutside = (e) => {
    const focusedElement = e.relatedTarget;
    const menuSelectorElement = document.getElementById(
      'menu-selector-container',
    );

    if (!menuSelectorElement?.contains(focusedElement)) {
      setIsOpen(false);
    }
  };

  const handleSelectMenu = (menuId: number, cartId: number) => {
    onSelectMenu(menuId, cartId);
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div
          className={styles.overlay}
        />
      )}
      <div
        className={styles.menu_selector_container}
        id="menu-selector-container"
      >
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          onBlur={handleClickOutside}
          className={`${styles.dropdown_button} ${(isHubActive || isOpen) ? styles.is_active : ''}`}
        >
          {`${menuSelectorDate} Menu`}
          {isOpen ? <ChevronUpIcon width={14} /> : <ChevronDownIcon width={14} />}
        </button>

        {isOpen && (
          <div
            className={styles.dropdown_container}
          >
            <MenuSelector
              menuWeeks={menuWeeks}
              handleSelectMenu={handleSelectMenu}
              currentMenuDate={menu?.deliveryOn}
              onClose={() => setIsOpen(false)}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default MenuSelectorContainer;
